export default "__VITE_ASSET__BGe6R_OT__"